import React, { useState, useEffect, useRef } from 'react';
import { showToast } from './Messages';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ScrollIntoView = ({ editorData, manualId, docId, devUserId, fullPath, title, docBox, isPreview = false }) => {
    const observer = useRef(null);
    const [like, setLike] = useState(false);
    const [dislike, setDislike] = useState(false);
    const [feedbackId, setFeedbackId] = React.useState('');
    const [comment, setComment] = React.useState('');
    const [showCommentBox, setShowCommentBox] = React.useState(false);
    const likeLabels = ['설명이 이해가 쉬워요.', '활용 예시가 많아요.', '문제가 해결됐어요.', '기타 의견'];
    const dislikeLabels = ['설명이 복잡해요.', '활용 예시가 부족해요.', '문제가 해결되지 않았어요.', '기타 의견'];
    const labels = like ? likeLabels : dislikeLabels;
    const type = like ? 'like' : 'dislike';
    const history = useNavigate();
    const LoginStates = useSelector(state => state.login);

    const moveTo = (path, state) => {
        history(`/${path}`, { state: state });
    }

    const handleClick = (type) => {
        setFeedbackId('');
        setShowCommentBox(false)
        setComment('');
        if (type === 'like') {
            setLike((prev) => !prev);
            setDislike(false);

        } else if (type === 'dislike') {
            setDislike((prev) => !prev);
            setLike(false);
        }
    };

    const handleFeedbackChange = (e) => {
        const selectedId = e.target.id;
        setFeedbackId(selectedId);

        if (selectedId.endsWith('-other')) {
            setShowCommentBox(true);
        } else {
            setShowCommentBox(false);
            setComment('');
        }
    };

    const feedbackSave = async () => {
        if (feedbackId !== '') {
            const selectedIndex = parseInt(feedbackId.split('-')[1], 10);
            const selectedLabel = labels[selectedIndex] || '';

            const body = JSON.stringify({
                feedbackId: feedbackId,
                manualId: manualId,
                docId: docId,
                content: selectedLabel,
                comment: comment.trim(),
                devUserId: devUserId
            });

            try {
                const response = await fetch('api/Document/FeedBackSave', {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json; charset=utf-8'
                    },
                    body: body
                });
                const result = await response.json();
                if (result.message === 'Success' && result.data.table !== undefined) {
                    if (result.data.table[0].status === 'OK') {
                        showToast('success', "소중한 의견 감사합니다.")
                    } else {
                        showToast('danger', '피드백 전송 오류 db: ', result.data.table[0].message);
                    }
                } else {
                    showToast('danger', '피드백 전송 오류: no data');
                }
            } catch (error) {
                showToast('danger', '피드백 전송 오류 server: ', error);
            }
        } else {
            showToast('warning', '항목을 선택해주세요.');
        }
    };

    const ClickIndex = (index) => {
        let offsetTop = 0;
        let topHeight = checkHeight();
        const contents = document.querySelector(`[data-id="${index}"]`);
        const scrollContainer = document.querySelector('.doc-wrap'); // 내부 스크롤 컨테이너 선택 (클래스 또는 ID 사용)

        if (contents && scrollContainer) {
            // 컨테이너 내부에서의 offset 계산
            const containerOffsetTop = contents.offsetTop - scrollContainer.offsetTop;
            offsetTop = containerOffsetTop + topHeight;

            // 내부 컨테이너의 스크롤 위치를 이동
            scrollContainer.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    };

    const decodeEntities = (data) => {
        const entitiesMap = {
            "&nbsp;": " ",
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
        };

        return data.replaceAll(/&[a-zA-Z0-9#]+;/g, (match) => entitiesMap[match] || match);
    }

    const findSubJects = () => {
        if (!editorData || editorData === "" || editorData === "No files..") return;
        const data = JSON.parse(editorData);
        let returnArray = [];
        returnArray.push({ index: -1, innerText: data.title, innerId: "0", level: 0 });
        const blocks = data.data.blocks;
        if(blocks && blocks.length > 0) {
            blocks.forEach((block, index) => {
                const isHeader = (block.type === 'header' && (block.data.level === 1 || block.data.level === 2 || block.data.level === 3))
                    || block.type === 'h1' || block.type === 'h2' || block.type === 'h3';
                if (isHeader) {
                    let text = decodeEntities(block.data.text).replaceAll(";", "");
                    returnArray.push({ index, innerText: text, innerId: block.id, level: block.data.level });
                }
            });
        }

        return returnArray;
    };

    const checkHeight = () => {
        let height = 0;
        const nav = document.querySelector(".doc-nav");
        const title = document.querySelector(".title-section");
        const tag = document.querySelector(".tag-section");
        if (nav) height = height + nav.clientHeight + 25;
        if (title) height = height + title.clientHeight + 50;
        if (tag) height = height + title.clientHeight + 20;
        return height;
    };
    let ankor = findSubJects();

    useEffect(() => {
        if (!ankor) return;

        // 각 subject 요소에 대해 observer를 추가
        ankor.forEach(subject => {
            const element = document.querySelector(`[data-id="${subject.innerId}"]`);
            if (element) observer.current?.observe(element);
        });
    }, [ankor]);

    const setChildByLevel = (data, currentLevel) => {
        const result = [];
        let currentParent = null;

        data.forEach((item) => {
            if (item.level === currentLevel) {
                currentParent = { ...item, children: [] };
                result.push(currentParent);
            } else if (item.level > currentLevel && currentParent) {
                currentParent.children.push(item);
            }
        });

        result.forEach((parent) => {
            if (parent.children.length > 0) {
                const nextLevel = Math.min(...parent.children.map((child) => child.level));
                parent.children = setChildByLevel(parent.children, nextLevel);
            }
        });

        return result;
    };

    const renderPageIndex = (data) => {
        if (data == null) return;
        return data.map((item, index) => (
            <div key={item.innerId} className={`page-index-depth${item.level}`}>
                <p className="page-index-each" onClick={() => ClickIndex(item.innerId)}>{item.innerText}</p>
                {item.children && renderPageIndex(item.children)}
            </div>
        ));
    };
    const filteredAnkor = ankor?.filter(item => item.level !== 0);
    const newAnkor = filteredAnkor != null && filteredAnkor.length > 0 ? setChildByLevel(filteredAnkor, filteredAnkor[0].level) : null;

    return (
        <div className="page-index">
            <nav>
                <h5>이 문서의 내용</h5>
                <div className='page-index-list'>
                    {renderPageIndex(newAnkor)}
                </div>
            </nav>
            {!isPreview && manualId !== null && manualId !== "" &&
            <div className='feedback'>
                <p className='feedback-title'>이 문서가 유익했나요?</p>
                <div className='btn-feedback-wrap'>
                    <button className='btn-good' onClick={() => handleClick('like')}>
                        <i className={`icoKdc20 like${like ? '-g' : ''}`}></i>
                        <p className='feedback-label'>도움이 됐어요</p>
                    </button>
                    <button className='btn-notgood' onClick={() => handleClick('dislike')}>
                        <i className={`icoKdc20 dislike${dislike ? '-r' : ''}`}></i>
                        <p className='feedback-label'>아쉬워요</p>
                    </button>
                </div>
                {(like || dislike) && (
                    <>
                        <ul className="feedback-list">
                            {labels.map((label, index) => (
                                <li className="feedback-list-each" key={index}>
                                    <input
                                        type="radio"
                                        id={`${type}-${index === labels.length - 1 ? 'other' : index}`}
                                        name="feedback"
                                        value={label}
                                        checked={feedbackId === `${type}-${index === labels.length - 1 ? 'other' : index}`}
                                        onChange={handleFeedbackChange}
                                    />
                                    <label htmlFor={`${type}-${index === labels.length - 1 ? 'other' : index}`}>
                                        {label}
                                    </label>
                                </li>
                            ))}
                            {showCommentBox && (
                                <li className="feedback-list-each" key={labels.length}>
                                    <input
                                        type="text"
                                        id="comment"
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                        placeholder="기타 의견을 입력해주세요"
                                    />
                                </li>
                            )}
                        </ul>
                        <button className="btn-send" onClick={feedbackSave}>
                            보내기
                        </button>
                    </>
                )}
            </div>
            }
            {!isPreview && LoginStates.userId && fullPath !== null && (
                <button className='page-inquiry' onClick={() => moveTo('MyPage/topicList', { current: 'topicList', locationFrom: 'document', locationCurrent: 'topicWrite', fullPath: fullPath, title: title, linkPath: window.location.pathname })}>
                    <i className='icoKdc32 page-inquiry'></i>
                    <p>이 문서에 대해 문의하기</p>
                </button>
            ) }
        </div>
    );
}

export default ScrollIntoView;
